module.exports = __webpack_public_path__ + "img/IMG_2667.ed3dc796.jpg";